import React, { useState } from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import PublicHeader from "../components/Layout/PublicHeader";
import Footer from "../components/Layout/Footer";
import "../styles/faq.css";

const FAQPage = () => {
  const faqData = [
    {
      id: 1,
      question: "Comment le tarif est-il calculé ?",
      answer: (
        <>
          <p>Le tarif dépend de trois éléments principaux :</p>
          <ul>
            <li>le temps de parcours en dynamique (trafic, distance, itinéraire),</li>
            <li>le poids de ton colis ou de ton chargement,</li>
            <li>l'option de livraison choisie : Flex, Planifiée ou Urgente.</li>
          </ul>
          <p>Notre système calcule automatiquement le prix le plus juste en temps réel en fonction de ton trajet et de ces paramètres.</p>
          <p>Un tarif minimum de 19,99 € s'applique à toute livraison, particuliers comme professionnels.</p>
        </>
      ),
    },
    {
      id: 2,
      question: "Quel est le poids et la taille maximum acceptés ?",
      answer: (
        <>
          <p>Nous acceptons les colis jusqu'à 50 kg par unité, avec un poids total pouvant atteindre 1 380 kg (capacité maximale de notre véhicule).</p>
          <p>Concernant les dimensions, l'ensemble du chargement ne doit pas dépasser les dimensions internes de notre camion, soit :</p>
          <p><strong>120 cm de large x 120 cm de haut x 280 cm de long</strong></p>
          <p>Nous pouvons également transporter certaines pièces longues jusqu'à 4 mètres, à condition qu'elles ne dépassent pas :</p>
          <p><strong>30 cm x 30 cm x 4 ml</strong></p>
        </>
      ),
    },
    {
      id: 3,
      question: "Dans quels magasins peux-tu récupérer mes colis ?",
      answer: (
        <>
          <p>Nous récupérons tes commandes dans la plupart des enseignes BTP, magasins spécialisés et dépôts matériaux, notamment :</p>
          <p>Point P, PUM, Tout Faire, Maison du Carrelage, CBL, Dispano, Leroy Merlin, Castorama, Rexel, Cedeo, Loxam…</p>
          <p>Nous intervenons également dans :</p>
          <ul>
            <li>les commerces locaux,</li>
            <li>les entrepôts professionnels,</li>
            <li>les domiciles de particuliers.</li>
          </ul>
          <p>Lors de ta commande, il te suffit d'indiquer l'adresse exacte du point de retrait.</p>
        </>
      ),
    },
    {
      id: 4,
      question: "Quels sont les jours et horaires de livraison ?",
      answer: (
        <>
          <p>Nous livrons du lundi au vendredi de 7h30 à 18h30 et le samedi de 7h30 à 13h, sous réserve des horaires d'ouverture des magasins et dépôts concernés.</p>
          <p>Les livraisons peuvent être effectuées :</p>
          <ul>
            <li>le matin,</li>
            <li>en journée,</li>
            <li>en fin d'après-midi, selon l'option sélectionnée (Flex, Planifiée ou Urgente).</li>
          </ul>
          <p>Lors de ta commande, tu peux choisir l'option et/ou l'horaire qui te convient.</p>
        </>
      ),
    },
    {
      id: 5,
      question: "Puis-je suivre ma livraison en temps réel ?",
      answer: (
        <>
          <p>Oui. Chaque livraison est suivie en temps réel.</p>
          <p>Une fois ta commande validée, tu retrouves le suivi dans ton espace personnel, rubrique "Historique de commandes".</p>
          <p>Ton espace personnel te permet de :</p>
          <ul>
            <li>voir la position du chauffeur,</li>
            <li>consulter les différents statuts de la livraison,</li>
            <li>connaître l'heure estimée d'arrivée,</li>
            <li>recevoir la confirmation de livraison (photo ou code de sécurité).</li>
          </ul>
          <p>Tu es informé à chaque étape.</p>
        </>
      ),
    },
    {
      id: 6,
      question: "Que se passe-t-il si je ne suis pas disponible lors de la livraison ?",
      answer: (
        <>
          <p>Si tu n'es pas disponible, plusieurs solutions sont possibles :</p>
          <ul>
            <li>désigner une personne sur place (collaborateur, voisin, gardien, collègue, etc.),</li>
            <li>demander un dépôt sécurisé à un endroit précis à proximité (le matériel est alors sous ta responsabilité après dépôt),</li>
            <li>reprogrammer la livraison selon nos disponibilités.</li>
          </ul>
          <p><strong>👉 Matériel non prêt ou non présent au retrait</strong></p>
          <p>Notre livreur attendra jusqu'à 15 minutes sur place. Au-delà, il quittera les lieux et un forfait de 19,90 € te sera facturé ; le reste de la commande sera remboursé.</p>
          <p><strong>👉 Absence lors de la livraison</strong></p>
          <p>En cas d'absence, le livreur attendra également 15 minutes. Passé ce délai :</p>
          <ul>
            <li>il faudra reprogrammer une livraison dans la journée en nous contactant via WhatsApp ; des frais complémentaires seront facturés,</li>
            <li>en l'absence d'instructions, la marchandise sera stockée à notre dépôt et une nouvelle livraison sera facturée.</li>
          </ul>
        </>
      ),
    },
    {
      id: 7,
      question: "Les colis sont-ils assurés ?",
      answer: (
        <>
          <p>Oui. Tous les colis transportés par Marion Livraison sont assurés pendant toute la durée du trajet, depuis le point de retrait jusqu'au lieu de livraison.</p>
          <p>L'assurance couvre notamment :</p>
          <ul>
            <li>les dommages liés au transport,</li>
            <li>la perte,</li>
            <li>les incidents directement imputables à la livraison.</li>
          </ul>
          <p>Pour les objets de forte valeur ou les charges spécifiques BTP, contacte-nous avant la prise en charge afin de vérifier les conditions particulières d'assurance.</p>
        </>
      ),
    },
    {
      id: 8,
      question: "Comment puis-je annuler ou modifier ma commande ?",
      answer: (
        <>
          <p>Tu peux annuler ta commande directement depuis ton espace client, jusqu'à 3 heures avant la prise en charge de ta livraison.</p>
          <p>Si ta commande est une urgence ou si l'annulation intervient dans les 3 heures précédant la prise en charge, un forfait de 19,90 € sera facturé.</p>
          <p>Si la prise en charge est déjà en cours, l'annulation ou la modification peut entraîner des frais supplémentaires, calculés en fonction de l'avancement de la mission.</p>
        </>
      ),
    },
  ];

  return (
    <div className="faq-page">
      <PublicHeader />

      {/* Hero Section */}
      <section className="faq-hero-section">
        <Container>
          <Row className="text-center">
            <Col>
              <h1 className="display-4 fw-bold mb-3">
                Foire Aux Questions
              </h1>
              <p className="lead text-muted">
                Retrouve toutes les réponses à tes questions sur nos services de livraison
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FAQ Section */}
      <section className="faq-content-section py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <Accordion defaultActiveKey="0">
                {faqData.map((faq) => (
                  <Accordion.Item eventKey={faq.id.toString()} key={faq.id} className="mb-3">
                    <Accordion.Header>
                      <span className="faq-question-number">Q{faq.id}</span>
                      <span className="faq-question-text">{faq.question}</span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="faq-answer">{faq.answer}</p>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact CTA Section */}
      <section className="faq-cta-section py-5 bg-light">
        <Container>
          <Row className="text-center">
            <Col>
              <h3 className="mb-3">Tu ne trouves pas la réponse à ta question ?</h3>
              <p className="text-muted mb-4">
                Notre équipe est à ta disposition pour répondre à toutes tes questions
              </p>
              <a href="/contact" className="btn btn-marion btn-lg">
                Nous contacter
              </a>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default FAQPage;
